import { useAtomCallback } from "jotai/utils";
import { useCallback } from "react";
import { logger } from "../../../datadog/logger";
import { UserType } from "../../../types";
import {
  DataChannelMessageType,
  roomAtom,
  useSendMessage,
} from "../../../video-sdk";
import { providerShortIdAtom } from "../../state";

/**
 * Returns a callback to handle when the completion status of the reflection
 * topic was updated successfuly for a provider. This callback sends a data
 * track message with the topic completion status if the provider is in a
 * session, otherwise it does nothing.
 */
export function useHandleReflectionTopicCompletionCallback() {
  const sendDataChannelMessage = useSendMessage();
  const getIsInSession = useAtomCallback(
    useCallback((get) => {
      return !!get(roomAtom);
    }, []),
  );

  const getProviderShortId = useAtomCallback(
    useCallback((get) => {
      return get(providerShortIdAtom);
    }, []),
  );

  return useCallback(
    (topic: { topicShortId: string; completed: boolean }) => {
      // Completing topic outside of a session - noop
      if (!getIsInSession()) {
        return;
      }
      const providerShortId = getProviderShortId();
      if (!providerShortId) {
        logger.warn("Handling topic completion without provider short ID");
      }
      sendDataChannelMessage({
        type: DataChannelMessageType.REFLECTION_TOPIC_UPDATE,
        topic: {
          ...topic,
          updatedAt: new Date().toISOString(),
        },
        sender: {
          entityType: UserType.PROVIDER,
          entityId: providerShortId ?? "",
        },
      });
    },
    [getProviderShortId, getIsInSession, sendDataChannelMessage],
  );
}
